import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { routerTransition } from '../../router.animations';
import { BackendService } from 'src/app/services/backend.service';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    animations: [routerTransition()]
})
export class DashboardComponent implements OnInit {
    public alerts: Array<any> = [];
    isActive: boolean;
    public sliders: Array<any> = [];
    error = false;
    showEdit: Boolean = false;
    collapsed: boolean;
    showDelete: Boolean = false;
    errorMessage: String = '';
    dataLoading = false;
    showMenu: string;
    idioma;
    private querySubscription;
    ide;
    public pushRightClass: string;
    selected_view = '';

    @Output() collapsedEvent = new EventEmitter<boolean>();


    constructor(private translate: TranslateService, private backendService: BackendService, private router: Router) {
        this.translate.addLangs(['es', 'pt']);
        this.translate.use(window.localStorage.getItem('idioma'));
        this.router.events.subscribe(val => {
            if (
                val instanceof NavigationEnd &&
                window.innerWidth <= 992 &&
                this.isToggled()
            ) {
                this.toggleSidebar();
            }
        });

        this.sliders.push(
            {
                imagePath: 'assets/images/slider1.jpg'
            },
            {
                imagePath: 'assets/images/slider2.jpg'
            },
            {
                imagePath: 'assets/images/slider3.jpg'

            },
            {
                imagePath: 'assets/images/slider4.jpg'
            },
            {
                imagePath: 'assets/images/slider5.jpg'
            },
            {
                imagePath: 'assets/images/slider6.jpg'
            },
        );

        this.alerts.push(
            {
                id: 1,
                type: 'success',
                message: `Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Voluptates est animi quibusdam praesentium quam, et perspiciatis,
                consectetur velit culpa molestias dignissimos
                voluptatum veritatis quod aliquam! Rerum placeat necessitatibus, vitae dolorum`
            },
            {
                id: 2,
                type: 'warning',
                message: `Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Voluptates est animi quibusdam praesentium quam, et perspiciatis,
                consectetur velit culpa molestias dignissimos
                voluptatum veritatis quod aliquam! Rerum placeat necessitatibus, vitae dolorum`
            }
        );
    }

    buscarUser(form) {
        window.localStorage.setItem('numberBuscar', form);
        window.localStorage.setItem('buscar', 'true');
        this.router.navigate(['layout/historial']);

    }

    ngOnInit() {
        if (localStorage.length <= 0) {
            this.router.navigate(['../login']);
        } else {
            if (localStorage.getItem('token') != null && localStorage.getItem('token') !== '') {
                this.isActive = false;
                this.collapsed = false;
                this.showMenu = '';
                this.pushRightClass = 'push-right';
                // document.getElementById('number').focus();
                this.selected_view = window.localStorage.getItem('selected_view');
            } else {
                this.router.navigate(['../login']);
            }
        }
    }


    toggleCollapsed() {
        this.collapsed = !this.collapsed;
        this.collapsedEvent.emit(this.collapsed);
    }

    isToggled(): boolean {
        const dom: Element = document.querySelector('body');
        return dom.classList.contains(this.pushRightClass);
    }

    changeLang(language: string) {
        this.translate.use(language);
    }

    toggleSidebar() {
        const dom: any = document.querySelector('body');
        dom.classList.toggle(this.pushRightClass);
    }

    eventCalled() {
        this.isActive = !this.isActive;
    }

    addExpandClass(element: any) {
        if (element === this.showMenu) {
            this.showMenu = '0';
        } else {
            this.showMenu = element;
        }
    }
    public closeAlert(alert: any) {
        const index: number = this.alerts.indexOf(alert);
        this.alerts.splice(index, 1);
    }


    addFichaIndividual() {
        console.log('navigating');
        switch (this.selected_view) {
            case 'researcher':
                this.router.navigate(['researcher/ciudadano'],{ queryParams: {add: true}});
                break;
            case 'institutional_user':
                this.router.navigate(['institutional/ciudadano'],{ queryParams: {add: true}});
                break;
            case 'collaborator':
                this.router.navigate(['collaborator/ciudadanoadd']);
                break;
            default:
                console.log('View not allow this function');
                break;
        }
    }

}
